import React from 'react';
import { FormattedMessage, useIntl } from 'gatsby-plugin-intl';

import { Heart } from '../../svgs/Heart';
import { LinkButton } from '../Button';
import { BlueShade } from '../../svgs/BlueShade';

export const Doctors = () => {
  const { formatMessage } = useIntl();

  return (
    <section className="relative py-4 md:py-24 md:pb-96 lg:py-48 bg-gradient-to-b md:bg-none from-blue-100 to-red-100">
      <div className="absolute top-0 left-0 w-full h-full hidden md:block">
        <BlueShade className="absolute overflow-hidden" />
      </div>
      <div className="w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:items-center">
        <svg width="78" viewBox="0 0 78 65" fill="none" className="md:hidden mb-4">
          <path
            d="M56 6.5603C56 4.35116 54.2091 2.5603 52 2.5603H44C41.7909 2.5603 40 4.35116 40 6.5603V20.5603C40 22.7694 38.2091 24.5603 36 24.5603H22C19.7909 24.5603 18 26.3512 18 28.5603V36.5603C18 38.7694 19.7909 40.5603 22 40.5603H36C38.2091 40.5603 40 42.3512 40 44.5603V58.5603C40 60.7694 41.7909 62.5603 44 62.5603H52C54.2091 62.5603 56 60.7694 56 58.5603V44.5603C56 42.3512 57.7909 40.5603 60 40.5603H74C76.2091 40.5603 78 38.7694 78 36.5603V28.5603C78 26.3512 76.2091 24.5603 74 24.5603H60C57.7909 24.5603 56 22.7694 56 20.5603V6.5603Z"
            fill="#90CDF4"
          />
          <path
            d="M40 3.5603C40 3.00802 39.5523 2.5603 39 2.5603H25C24.4477 2.5603 24 3.00802 24 3.5603V23.5603C24 24.1126 23.5523 24.5603 23 24.5603H3C2.44772 24.5603 2 25.008 2 25.5603V39.5603C2 40.1126 2.44772 40.5603 3 40.5603H23C23.5523 40.5603 24 41.008 24 41.5603V61.5603C24 62.1126 24.4477 62.5603 25 62.5603H39C39.5523 62.5603 40 62.1126 40 61.5603V41.5603C40 41.008 40.4477 40.5603 41 40.5603H61C61.5523 40.5603 62 40.1126 62 39.5603V25.5603C62 25.008 61.5523 24.5603 61 24.5603H41C40.4477 24.5603 40 24.1126 40 23.5603V3.5603Z"
            fill="white"
            stroke="#2A4365"
            strokeWidth="4"
          />
        </svg>

        <div className="md:w-96 lg:w-auto">
          <FormattedMessage id="doctors.title">
            {(text) => (
              <h2
                className="text-2xl md:text-4xl lg:text-6xl font-heading font-bold mb-8 md:mb-6 lg:mb-12 lg:text-center"
                dangerouslySetInnerHTML={{ __html: text }}
              />
            )}
          </FormattedMessage>
          <div className="md:text-lg font-medium flex">
            <div className="lg:w-96 flex-1 flex flex-col items-start">
              <p className="mb-8">{formatMessage({ id: 'doctors.description' })}</p>
              <LinkButton href="/screens">{formatMessage({ id: 'doctors.cta' })}</LinkButton>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-end">
          <svg width="88" viewBox="0 0 88 66" fill="none" className="md:hidden mt-4">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.1083 7.90602C26.3802 4.62333 30.8172 2.77921 35.4436 2.77921C40.07 2.77921 44.507 4.62333 47.7789 7.90602L52.8909 13.0322L58.003 7.90602C59.6125 6.2336 61.5377 4.89962 63.6663 3.98191C65.795 3.06421 68.0844 2.58117 70.4011 2.56096C72.7177 2.54076 75.0152 2.9838 77.1594 3.86424C79.3036 4.74468 81.2516 6.04488 82.8898 7.68897C84.528 9.33307 85.8235 11.2881 86.7008 13.4401C87.578 15.5921 88.0195 17.8978 87.9993 20.2228C87.9792 22.5479 87.4979 24.8456 86.5835 26.9819C85.6691 29.1182 84.3399 31.0504 82.6735 32.6657L52.8909 62.5603L23.1083 32.6657C19.8375 29.382 18 24.929 18 20.2859C18 15.6427 19.8375 11.1897 23.1083 7.90602Z"
              fill="#FEB2B2"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.10834 7.90602C10.3802 4.62333 14.8172 2.77921 19.4436 2.77921C24.07 2.77921 28.507 4.62333 31.7789 7.90602L36.8909 13.0322L42.003 7.90602C43.6125 6.2336 45.5377 4.89962 47.6663 3.98191C49.795 3.06421 52.0844 2.58117 54.4011 2.56096C56.7177 2.54076 59.0152 2.9838 61.1594 3.86424C63.3036 4.74468 65.2516 6.04488 66.8898 7.68897C68.528 9.33307 69.8235 11.2881 70.7008 13.4401C71.578 15.5921 72.0195 17.8978 71.9993 20.2228C71.9792 22.5479 71.4979 24.8456 70.5835 26.9819C69.6691 29.1182 68.3399 31.0504 66.6735 32.6657L36.8909 62.5603L7.10834 32.6657C3.83747 29.382 2 24.929 2 20.2859C2 15.6427 3.83747 11.1897 7.10834 7.90602V7.90602Z"
              fill="white"
              stroke="#742A2A"
              strokeWidth="4"
            />
          </svg>
        </div>
      </div>
      <div className="absolute bottom-0 right-0 w-full h-full hidden md:block">
        <Heart className="absolute overflow-hidden" />
      </div>
    </section>
  );
};
